import { createContext } from 'react'

export const InputBlockContext = createContext({
  portalId: '',
})
